// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__BQ3qf","content":"Home_content__+Tt-K","title":"Home_title__DIZOv","subTitle":"Home_subTitle__2pG4Q","btnContainer":"Home_btnContainer__QuSkp"};